import React, { FC } from "react";
import { IStickyButtonConfig, StickyCTABar } from "component-library";
import { useTranslation } from "i18n";
import { getTagminSelfTapeUrl } from "pages/SelfTapeRequestPage/SelfTapeRequestAgentParts/helpers";
import { getCancelButton } from "pages/SelfTapeRequestPage/helpers";

interface Props {
  selfTapeRequestId: string;
  submitButtonConfig: IStickyButtonConfig;
  isAccepted?: boolean;
}

const AgentTagTapesActionFooter: FC<Props> = ({
  selfTapeRequestId,
  submitButtonConfig,
  isAccepted,
}) => {
  const { t } = useTranslation();

  return (
    <StickyCTABar
      prev={getCancelButton(t)}
      cancel={{
        text: t("common:selfTapes.request.action.openInTagmin"),
        onClick: () =>
          window.open(getTagminSelfTapeUrl(selfTapeRequestId), "_blank"),
      }}
      next={!isAccepted ? submitButtonConfig : undefined}
      ctaBarAdditionalClassName="max-w-[1440px]"
    />
  );
};

export default AgentTagTapesActionFooter;
